/* eslint-disable import/prefer-default-export */
import { StageStatus } from '../../Components/Progress/Progress.helpers';

export const getStagesToUpdate = ({
  progressBarStages,
  currentPage,
  isFinalPageBeforeSubmission,
}) => {
  if (!progressBarStages || !Array.isArray(progressBarStages) || !currentPage) {
    return [];
  }

  const stagesToUpdate = [];

  const completeSkippedStages = (stage) => {
    const stageIndex = progressBarStages.findIndex((s) => s.id === stage.id);
    if (stageIndex <= 0) return;

    const previousStage = progressBarStages[stageIndex - 1];
    if (
      previousStage &&
      previousStage.pages.length === 0 &&
      previousStage.status !== StageStatus.COMPLETED
    ) {
      // Only add if not already in stagesToUpdate
      if (!stagesToUpdate.some((s) => s.id === previousStage.id)) {
        stagesToUpdate.push({
          ...previousStage,
          status: StageStatus.COMPLETED,
        });
      }
    }
  };

  // Find all stages that contain the current page (for non-final page)
  const stagesWithCurrentPage = isFinalPageBeforeSubmission
    ? [progressBarStages[progressBarStages.length - 1]] // Only last stage for final page
    : progressBarStages.filter(
        (stage) => stage.pages && stage.pages.includes(currentPage)
      );

  // The last stage containing the current page should be marked as CURRENT
  const lastStageWithCurrentPage =
    stagesWithCurrentPage[stagesWithCurrentPage.length - 1];
  const lastStageIndex = lastStageWithCurrentPage
    ? progressBarStages.findIndex((s) => s.id === lastStageWithCurrentPage.id)
    : -1;

  // Process each stage
  progressBarStages.forEach((stage, index) => {
    // Skip if already in stagesToUpdate (from completeSkippedStages)
    if (stagesToUpdate.some((s) => s.id === stage.id)) {
      return;
    }

    let newStatus = stage.status;
    const stageIndex = progressBarStages.findIndex((s) => s.id === stage.id);

    if (isFinalPageBeforeSubmission) {
      // For final page, mark last stage as CURRENT, others as COMPLETED
      if (index === progressBarStages.length - 1) {
        newStatus = StageStatus.CURRENT;
      } else if (stage.status !== StageStatus.COMPLETED) {
        newStatus = StageStatus.COMPLETED;
      }
    } else if (stage === lastStageWithCurrentPage) {
      // This is the last stage containing the current page
      if (stage.status !== StageStatus.COMPLETED) {
        newStatus = StageStatus.CURRENT;
        completeSkippedStages(stage);
      }
    } else if (lastStageIndex >= 0 && stageIndex < lastStageIndex) {
      // This is a stage before the last stage containing current page
      if (stage.status !== StageStatus.COMPLETED) {
        newStatus = StageStatus.COMPLETED;
      }
    } else if (stage.pages && stage.pages.some((page) => page < currentPage)) {
      // This is a stage with all pages before current page
      if (stage.status !== StageStatus.COMPLETED) {
        newStatus = StageStatus.COMPLETED;
      }
    } else if (
      stage.pages &&
      stage.pages.length === 0 &&
      stageIndex < progressBarStages.length - 1
    ) {
      // This is a skipped stage (empty pages) that's not the last stage
      if (stage.status !== StageStatus.COMPLETED) {
        newStatus = StageStatus.COMPLETED;
      }
    }

    if (newStatus !== stage.status) {
      stagesToUpdate.push({ ...stage, status: newStatus });
    }
  });

  return stagesToUpdate;
};
